var map = {
	"./adminprofile/list": [
		1896,
		20
	],
	"./agentprofile/list": [
		1897,
		23
	],
	"./ai_assistant/list": [
		1898,
		26
	],
	"./api_key/list": [
		1899,
		29
	],
	"./canned_answer/list": [
		1900,
		34
	],
	"./chat_configuration/list": [
		2065,
		4
	],
	"./client/list": [
		1901,
		37
	],
	"./destination_restrictor/list": [
		1902,
		39
	],
	"./disposition/list": [
		1903,
		42
	],
	"./field/list": [
		1904,
		45
	],
	"./form/list": [
		1905,
		48
	],
	"./form_website/list": [
		1906,
		51
	],
	"./gdpr/list": [
		1907,
		53
	],
	"./invoice/list": [
		1908,
		55
	],
	"./journey/list": [
		1909,
		61
	],
	"./journey_draft/list": [
		1910,
		64
	],
	"./journey_trigger/list": [
		1911,
		65
	],
	"./journey_variable/list": [
		1912,
		68
	],
	"./list/list": [
		1913,
		71
	],
	"./list_file/list": [
		1914,
		74
	],
	"./mail_account/list": [
		1915,
		77
	],
	"./operational_hours/list": [
		1916,
		80
	],
	"./organization/list": [
		1917,
		83
	],
	"./pause/list": [
		1918,
		86
	],
	"./phonenumber_monthly_cost/list": [
		1919,
		89
	],
	"./phonenumber_monthly_cost_parent/list": [
		1920,
		92
	],
	"./phonenumber_purchase/list": [
		1921,
		96
	],
	"./phonenumber_setup_cost/list": [
		1922,
		99
	],
	"./phonenumber_setup_cost_parent/list": [
		1923,
		102
	],
	"./points_system/list": [
		1924,
		106
	],
	"./prepaid_credit/list": [
		1925,
		109
	],
	"./queue/list": [
		1926,
		112
	],
	"./release/list": [
		1927,
		113
	],
	"./signature/list": [
		1928,
		116
	],
	"./skill/list": [
		1929,
		119
	],
	"./sla_policy/list": [
		1930,
		122
	],
	"./sound/list": [
		1931,
		125
	],
	"./stats_alarm/list": [
		1932,
		128
	],
	"./stats_custom_metric/list": [
		1933,
		131
	],
	"./stats_report/list": [
		1934,
		134
	],
	"./stats_widget/list": [
		1935,
		137
	],
	"./superadmin_profile/list": [
		1936,
		140
	],
	"./tag/list": [
		1937,
		143
	],
	"./tariff/list": [
		1938,
		146
	],
	"./tariff_parent/list": [
		1939,
		149
	],
	"./team/list": [
		1940,
		152
	],
	"./text_message_source/list": [
		1941,
		10
	],
	"./time_interval/list": [
		1942,
		156
	],
	"./user/list": [
		1943,
		159
	],
	"./voice_asterisk/list": [
		1944,
		162
	],
	"./voice_asterisk_downgrade/list": [
		1945,
		165
	],
	"./voice_recording_transcript_setting/list": [
		1946,
		169
	],
	"./voice_route/list": [
		1947,
		172
	],
	"./voice_shortcut/list": [
		1948,
		175
	],
	"./voice_trunk/list": [
		1949,
		178
	],
	"./voice_voicemail/list": [
		1950,
		181
	],
	"./wallboard/list": [
		1951,
		184
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1876;
module.exports = webpackAsyncContext;